export const isEmbedCalculator = () => window.location.search.includes('?embed') || window.location.search.includes('&embed');

export const isSalesDemoMode = () => window.location.search.includes('?salesdemo') || window.location.search.includes('&salesdemo');
